import React, { useEffect, useState } from 'react';
import { ButtonSecondary } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

const GroupedImageSelect = (props) => {
  const {
    fieldId,
    imageOptions,
    setFormSubmissionPayload,
    formSubmissionPayload,
  } = props;

  const [selectedImage, setSelectedImage] = useState('');
  const handleClick = (value) => {
    setSelectedImage(value);
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      [fieldId]: value,
    });
  };

  useEffect(() => {
    if (formSubmissionPayload[fieldId]) {
      setSelectedImage(formSubmissionPayload[fieldId]);
    }
  }, [formSubmissionPayload]);
  return (
    <div id={fieldId} className="row margin-2-t width-full">
      {imageOptions.map((imageOption) => {
        const {
          fieldId: imagefieldId, fieldValue, cssProperties, imgProps,
        } = imageOption;
        return (
          <ButtonSecondary
            key={imagefieldId}
            onClick={() => handleClick(fieldValue)}
            className={`${cssProperties.imageStyle} ${fieldValue === selectedImage ? 'border-dark-xs-up smart-field active' : ''}`}
          >
            <div className={cssProperties.style}>
              {imgProps.style ? (
                <img
                  id={imagefieldId}
                  title={imgProps.title}
                  alt={imgProps.alt}
                  src={imgProps.src}
                  style={{
                    width: '100%', height: '50px', textAlign: 'center',
                  }}
                />
              ) : (
                <img
                  id={imagefieldId}
                  title={imgProps.title}
                  alt={imgProps.alt}
                  src={imgProps.src}
                  className={imgProps.imageClass ? imgProps.imageClass : ''}
                  style={{ maxWidth: imgProps.maxWidth ? `${imgProps.maxWidth}` : '100%' }}
                />
              )}
            </div>
          </ButtonSecondary>
        );
      }
      )}
    </div>
  );
};

GroupedImageSelect.propTypes = {
  fieldId: PropTypes.string,
  imageOptions: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default GroupedImageSelect;
